export default __webpack_public_path__ + "static/media/mafia-win.5597d702.jpg";